"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_uid_1 = require("react-uid");
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const AccessTime_1 = __importDefault(require("@mui/icons-material/AccessTime"));
const Today_1 = __importDefault(require("@mui/icons-material/Today"));
const MultiSelect_1 = __importDefault(require("../FormFields/MultiSelect"));
const AreaSelect_1 = __importDefault(require("../FormFields/AreaSelect"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const helpers_1 = require("../../../common/helpers/helpers");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const withLazy_1 = __importDefault(require("../../../common/decorators/withLazy"));
const BasketItems_1 = __importDefault(require("./BasketItems"));
const TextField_1 = __importDefault(require("../FormFields/TextField"));
const SingleSelect_1 = __importDefault(require("../FormFields/SingleSelect"));
const AcceptTerms_1 = __importDefault(require("../FormFields/AcceptTerms"));
const TimeSuggestions_1 = __importDefault(require("../Booking/TimeSuggestions"));
const MultiUnitSelect_1 = __importDefault(require("../FormFields/MultiUnitSelect"));
const DateAndTime = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "DateAndTime1524" */ '../FormFields/DateAndTime')))));
const LoaderWrapper = styled_components_1.default.div `
  position: relative;
  padding: 25px 0;
  > div {
    position: relative;
    display: block;
    left: 0;
    top: 0;
    margin: 0 auto;
  }
`;
const StaticDateAndTime = styled_components_1.default.div `
  padding-left: 16px;
`;
const StaticTime = styled_components_1.default.div `
  display: flex;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ededed;
    margin-right: 5px;
    padding: 5px;
    border-radius: 5px;
    svg {
      margin-right: 5px;
    }
  }
`;
const FormFields = (props) => {
    const { fields, setFormFields, timezone, orderData, showMenu, deleteItemFromBasket, reviewOrder, timeSuggestionsTitle, timeSuggestionsError, timeSuggestionsHint, timeSuggestions, fetchingTimeSuggestions, fetchSuggestions, activeItem, disableStartTime, currentLocale, } = props;
    const shoppingCartField = fields.find((field) => field.type === 'shopping_cart');
    const handleValueChange = (activeField) => event => {
        const newValue = event.target.value;
        setFormFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: newValue, errors: [] });
            }
            return field;
        }));
        if (newValue && activeField.id === 'pax' && !fetchingTimeSuggestions) {
            fetchSuggestions();
        }
    };
    const handleAcceptTermsChange = (activeField, termsAccepted) => {
        setFormFields(fields.map(field => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: termsAccepted, errors: [] });
            }
            return field;
        }));
    };
    const handleMultiSelectChange = (activeField) => {
        setFormFields(fields.map(field => {
            if (field.id === activeField.id) {
                const multiSelectValue = activeField.options.filter(option => option.selected).map(option => option.id);
                return Object.assign(field, { value: multiSelectValue, errors: [] });
            }
            return field;
        }));
    };
    const getTimeFromISODate = (isoDate) => isoDate
        .split('T')[1]
        .split('+')[0]
        .substr(0, 5);
    const formatDate = (date) => `${date.getFullYear()}/${date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}/${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
    const handleDateAndTimeChange = (activeField, selectedDate) => {
        const fullDateTime = `${formatDate(new Date(selectedDate))} ${activeField.type === 'datetime' ? helpers_1.Helpers.getHourFromDate(selectedDate) : ''}`;
        setFormFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, {
                    value: fullDateTime,
                    errors: [],
                });
            }
            return field;
        }));
        if (activeField.id === 'starts_at' && !fetchingTimeSuggestions) {
            fetchSuggestions();
        }
    };
    const formatDateAndTime = (dateField) => {
        if (!dateField.value) {
            const dateAndTime = dateField.placeholder.split(' ');
            const time = dateAndTime.length > 1
                ? dateAndTime[1]
                : `${helpers_1.Helpers.getHourFromDate(new Date().toString(), timezone).substr(0, 2)}:00`;
            return `${formatDate(new Date())} ${time}`;
        }
        if (dateField.value.split('T').length > 1) {
            return `${formatDate(new Date(dateField.value))} ${getTimeFromISODate(dateField.value)}`;
        }
        return dateField.value;
    };
    const handleSingleSelectChange = (activeField, selectedOption) => {
        setFormFields(fields.map(field => {
            if (field.id === activeField.id) {
                return Object.assign(field, {
                    value: selectedOption,
                    errors: [],
                });
            }
            return field;
        }));
        if ((activeField.type === 'table_select' || activeField.type === 'area_select') && !fetchingTimeSuggestions) {
            fetchSuggestions();
        }
    };
    const handleSuggestionClick = (selectedSuggestion) => {
        const fullDate = `${formatDate(new Date(selectedSuggestion.value))} ${getTimeFromISODate(selectedSuggestion.value)}`;
        setFormFields(fields.map(field => {
            if (field.id === 'starts_at') {
                return Object.assign(field, {
                    value: fullDate,
                    errors: [],
                });
            }
            return field;
        }));
    };
    const handleMultiUnitSelectChange = (activeField) => {
        setFormFields(prevFields => {
            const newFields = prevFields.map(field => {
                if (field.id === activeField.id) {
                    const multiSelectValue = activeField.options
                        .filter(option => option.selected)
                        .map(option => ({ id: option.id, quantity: option.quantity || 1 }));
                    return Object.assign({}, field, { value: multiSelectValue, errors: [] });
                }
                return field;
            });
            if (activeField.type === 'area_multi_select' && !fetchingTimeSuggestions) {
                fetchSuggestions(newFields);
            }
            return newFields;
        });
    };
    const renderFormFields = () => fields.map((field) => {
        const { type } = field;
        switch (type) {
            case 'datetime':
            case 'date': {
                const fieldData = Object.assign(field, {
                    value: formatDateAndTime(field),
                });
                if (disableStartTime && activeItem && activeItem.content && field.id === 'starts_at') {
                    return (react_1.default.createElement(StaticDateAndTime, { className: "static-date-and-time", key: (0, react_uid_1.uid)(field) },
                        react_1.default.createElement("p", null,
                            " ",
                            i18n_js_1.default.t('date_and_time'),
                            " "),
                        react_1.default.createElement(StaticTime, null,
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(AccessTime_1.default, null),
                                getActivityTime(activeItem.content, currentLocale, timezone)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(Today_1.default, null),
                                getActivityDate(activeItem.content.start, currentLocale)))));
                }
                return (react_1.default.createElement(react_1.default.Fragment, { key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(DateAndTime, { fieldData: fieldData, onChange: handleDateAndTimeChange, withPastDates: true })),
                    field.id === 'starts_at' && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, fetchingTimeSuggestions ? (react_1.default.createElement(LoaderWrapper, null,
                        react_1.default.createElement(Loader_1.default, null))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(TimeSuggestions_1.default, { suggestions: timeSuggestions, title: timeSuggestionsTitle, error: timeSuggestionsError, hint: timeSuggestionsHint, handleSuggestionClick: handleSuggestionClick })))))));
            }
            case 'table_select':
            case 'area_select':
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(AreaSelect_1.default, { fieldData: field, onChange: handleSingleSelectChange })));
            case 'single_select':
            case 'single_select_inline': {
                const fieldData = !field.value
                    ? Object.assign(field, {
                        value: field.options[0].label,
                    })
                    : field;
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(fieldData) },
                    react_1.default.createElement(SingleSelect_1.default, { fieldData: fieldData, onChange: handleSingleSelectChange })));
            }
            case 'multi_select':
            case 'multi_select_inline': {
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(MultiSelect_1.default, { fieldData: field, onChange: handleMultiSelectChange })));
            }
            case 'accept_terms':
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(AcceptTerms_1.default, { fieldData: field, onChange: handleAcceptTermsChange })));
            case 'section_heading':
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement("h3", null, field.label)));
            case 'area_multi_select':
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(MultiUnitSelect_1.default, { fieldData: field, onChange: handleMultiUnitSelectChange })));
            case 'shopping_cart':
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: "basket-items" },
                    react_1.default.createElement(BasketItems_1.default, { orderData: orderData, showMenu: showMenu, deleteItemFromBasket: deleteItemFromBasket, reviewOrder: reviewOrder, shoppingCartField: shoppingCartField })));
            default:
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(TextField_1.default, { fieldData: field, onChange: handleValueChange })));
        }
    });
    return react_1.default.createElement(react_1.default.Fragment, null, renderFormFields());
};
function getActivityDate(dateStart, locale) {
    const { date } = helpers_1.Helpers.getDateFromStringDependingLocale(dateStart, locale);
    return `${date}`;
}
function getActivityTime(content, locale, timezone) {
    if (!content.showStartTime && !content.showEndTime) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const startTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.start, locale, timezone).time;
    const endTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.end, locale, timezone).time;
    if (content.showStartTime && content.showEndTime) {
        return `${startTime} - ${endTime}`;
    }
    return startTime;
}
const mapStoreToProps = store => ({
    timezone: store.getValue('timezone'),
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(FormFields);
